import { Ref } from 'vue'

import { useToggle } from '@/shared/composables/use-toggle'

interface UseEmojiResult {
  showEmojiList: Ref<boolean>
  toggleEmojiList: () => void
  openEmojiList: () => void
  closeEmojiList: () => void
}

export function useEmoji (): UseEmojiResult {
  const {
    value: showEmojiList,
    toggle: toggleEmojiList,
    enable: openEmojiList,
    disable: closeEmojiList,
  } = useToggle(false)

  return {
    showEmojiList,
    toggleEmojiList,
    openEmojiList,
    closeEmojiList,
  }
}
